import Product from './Product';

/**
 * Represents a subscription, several of which may be present per order.
 */
export default class Bundle {
  readonly key = Date.now().toString(24);
  energyItems: Product[] = [];

  transferredPhone?: string = null;
  contactPhone?: string = null;
  address?: string = null;
  postalCode?: string = null;
  city?: string = null;

  constructor(deriveFrom?: Partial<Bundle>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }
  }

  get valid() {
    return this.energyItems?.length > 0;
  }
}